import type { SignupListsResponse, SignupListType } from "shell/console/types";

export const DOMAIN_PATTERN = /^(?=.{1,253}$)([a-z0-9-]{1,63}\.)+[a-z]{2,}$/;

export const normalizeDomain = (domain: string): string =>
  domain.trim().toLowerCase();

export const getActiveListDomains = (
  lists: SignupListsResponse,
  list: SignupListType,
): string[] => (list === "allow" ? lists.allow : lists.block);

export const getOtherListDomains = (
  lists: SignupListsResponse,
  list: SignupListType,
): string[] => (list === "allow" ? lists.block : lists.allow);
